import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';

import { columnChartConfiguration } from './utilities/helpers';

const ColumnChart = ({ onChartCallback, prescriptText, series, xAxis, yAxis, ...props }) => {
  return (
    <Chart
      onChartCallback={onChartCallback}
      options={merge({}, columnChartConfiguration, {
        series,
        type: 'column',
        xAxis,
        yAxis,
        ...props,
      })}
      prescriptText={prescriptText}
      {...props}
    />
  );
};

ColumnChart.propTypes = {
  onChartCallback: PropTypes.func,
  prescriptText: PropTypes.node,
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
};

export default ColumnChart;
